<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <div class="navbar-brand-box" style="background-color: #ffffff;">
        <a href="javascript:void()" [routerLink]="'./managefleets/managefleet'"  class="logo logo-light">
       <span class="logo-lg">
            <img *ngIf="imageUrl" [src]="imageUrl" alt="" height="50" style="height: auto !important; width: 180px;max-height: 80px !important; margin-left: -60px;">
            <img *ngIf="!imageUrl" src="assets/images/defaultFleet.png" alt="" height="50" style="height: 60px!important; width: auto;" class="main-logo">
          </span>
          <span class="logo-sm">
            <img *ngIf="imageUrl" [src]="imageUrlSmall" alt="" height="50" style="height: 50px!important;    margin-left: -12px !important;
    margin-top: -1px !important;" class="main-logo">
          </span>
        </a>
      </div>
      <button type="button" class="btn btn-sm px-3 font-size-16 header-item" id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars" style="color: #ffffff;"></i>
      </button>
    </div>
    <!-- For Admin Role -->
    <ng-container *ngIf="user =='role_admin'">
      <div class="d-flex">
        <div class="dropdown d-inline-block">
          <button type="button" class="btn header-item" (click)="testAPI()">
            <span class="d-none d-xl-inline-block ms-1" style="font-size:14px !important">Remote APIs</span>
          </button>
        </div>
        <div class="dropdown d-inline-block">
          <button type="button" class="btn header-item" (click)="faqbtn()">
            <span class="d-none d-xl-inline-block ms-1" style="font-size:14px !important">FAQ</span>
          </button>
        </div>
        <div class="dropdown d-inline-block" ngbDropdown>
          <button type="button" class="btn header-item" ngbDropdownToggle id="page-header-user-dropdown">
            <span class="d-none d-xl-inline-block ms-1" style="font-size:14px !important">Welcome ! {{loginUser?.name}}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
            <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()"><i
                class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
              {{ 'Logout' | translate}}</a>
          </div>
        </div>
      </div>
    </ng-container>
    <!-- For Consumer Role Fleet -->
    <ng-container *ngIf="user =='role_consumer_fleet'">
      <div class="d-flex">
        <div class="dropdown d-inline-block">
          <i class="bx bx-support btn header-item" routerLink="/adlp/managefleets/customer-support"  style="font-size: 18px;"></i>
        </div>
        <div class="dropdown d-inline-block">
         <span [title]="isDisabledUser() ? 'Please contact sales to enable' : ''">
  <button type="button"
          class="btn header-item"
          (click)="testAPI()"
          [disabled]="isDisabledUser()">
      <span class="d-none d-xl-inline-block ms-1" style="font-size:14px !important">
        Remote APIs
      </span>
  </button>
</span>

        </div>
        <div class="dropdown d-inline-block">
          <button type="button" class="btn header-item" (click)="faqbtn()">
            <span class="d-none d-xl-inline-block ms-1" style="font-size:14px !important">FAQ</span>
          </button>
        </div> 
        <div class="dropdown d-inline-block" ngbDropdown>
          <button type="button" class="btn header-item" ngbDropdownToggle id="page-header-user-dropdown">
            <span class="d-none d-xl-inline-block ms-1" style="text-transform: capitalize;font-size:14px !important; "> Welcome,
              {{loginUser?.name}}!</span>
              <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
           
              <a class="dropdown-item d-block" href="javascript: void(0)" (click)="requestSent(deleteConsumerData)"><i
                class="bx bx-cog bx-spin font-size-16 align-middle me-1"></i>
              Settings</a>
              <a class="dropdown-item d-block" href="javascript: void(0)" (click)="largeModal3(support)"><i
                class="bx bx-wrench font-size-16 align-middle me-1"></i>
              Support</a>
          <div class="dropdown-divider"></div>
            <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()"><i
                class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
              {{ 'Logout' | translate}}</a>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="user =='read_only'">
      <div class="d-flex">
        <div class="dropdown d-inline-block">
          <button type="button" class="btn header-item" (click)="testAPI()">
            <span class="d-none d-xl-inline-block ms-1" style="font-size:14px !important">Remote APIs</span>
          </button>
        </div>
        <div class="dropdown d-inline-block">
          <button type="button" class="btn header-item" (click)="faqbtn()">
            <span class="d-none d-xl-inline-block ms-1" style="font-size:14px !important">FAQ</span>
          </button>
        </div> 
        <div class="dropdown d-inline-block" ngbDropdown>
          <button type="button" class="btn header-item" ngbDropdownToggle id="page-header-user-dropdown">
            <span class="d-none d-xl-inline-block ms-1" style="text-transform: capitalize;font-size:14px !important; "> Welcome,
              {{loginUser?.name}}!</span>
              <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </button>
         
          <!-- <button type="button" class="btn header-item" ngbDropdownToggle id="page-header-user-dropdown">
            <span class="d-none d-xl-inline-block ms-1" style="text-transform: capitalize; margin-top:-11px"> 
              <button class="data-demo" (click)="logout()">Logout</button>
            </span>
          </button> -->
          <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
           
              <a class="dropdown-item d-block" href="javascript: void(0)" (click)="requestSent(deleteConsumerData)"><i
                class="bx bx-cog bx-spin font-size-16 align-middle me-1"></i>
              Settings</a>
              <a class="dropdown-item d-block" href="javascript: void(0)" (click)="largeModal3(support)"><i
                class="bx bx-wrench font-size-16 align-middle me-1"></i>
              Support</a>
          <div class="dropdown-divider"></div>
            <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()"><i
                class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
              {{ 'Logout' | translate}}</a>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="user =='role_consumer'">
      <div class="d-flex">
        <div class="dropdown d-inline-block" ngbDropdown>
          <button type="button" class="btn header-item" ngbDropdownToggle id="page-header-user-dropdown">
            <span class="d-none d-xl-inline-block ms-1" style="text-transform: capitalize;font-size:14px !important; "> Welcome,
              {{loginUser?.name}}!</span>
              <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </button>
         <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
            <a class="dropdown-item d-block" href="javascript: void(0)" (click)="largeModal3(support)"><i
                class="bx bx-wrench font-size-16 align-middle me-1"></i>
              Support</a>
              <!-- <div class="dropdown-divider"></div> -->
              <!-- <a class="dropdown-item d-block" href="javascript: void(0)" (click)="requestSent(deleteConsumerData)"><i
                class="bx bx-cog bx-spin font-size-16 align-middle me-1"></i>
              Setting</a> -->
            <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()"><i
                class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
              {{ 'Logout' | translate}}</a>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</header>

<ng-template #deleteConsumerData let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Upload Logo</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal();modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="image-upload">
      <div class="preview-container" *ngIf="preview">
        <img alt="image upload" [src]="preview" class="img1">
      </div>
      <input type="file" (change)="onFileSelected($event)" accept="image/*" style="margin-left: 28px; margin-top: 12px;">
    </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn-login-new" [disabled]="!selectedImage" (click)="modal.close('Save click');changeLogo()">Upload Logo</button>
    <!-- <button type="reset" class="btn btn-light m-1" (click)="closeModal();modal.close('Close click')">No</button> -->
  </div>
</ng-template>

<ng-template #support let-modal class="modal-width" style="margin-top: -60px;">
  <div class="modal-header" style="margin-top: -20px;">
      <h5 class="modal-title mt-0 support">FleetReady Support</h5><br>
      <span class="jira-po">Powered by Jira</span>
      <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')" aria-hidden="true"></button>
  </div>
  <div class="modal-body" style="height: 280px;">
     <h6 class="message-support">Require assistance or technical support? Click on the link below to raise a support ticket and we'll promptly address your concerns.</h6>
     <ul>
      <li class="product">Product trial questions</li>
      <li class="product">Report a bug</li>
      <li class="product">Suggest a new feature</li>
      <li class="product">Suggest Improvement</li>
      <li class="product">Other questions</li>
     </ul>
     <div class="row">
      <div class="col-xs-12 col-lg-12 text-center">
        <a class="btn btn-primary data-demo-ticket" href="https://cerebrumx.atlassian.net/jira/servicedesk/projects/CS/boards/25" target="_blank" type="submit">Raise A Ticket</a>
      </div>
     </div>
  </div>
</ng-template>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#fff" type="ball-circus" [fullScreen]="true">
  <p style="color: white"> Loading... </p>
  </ngx-spinner>